import { useState } from "react";
import { Link } from "react-router";

const TEAL = "#4abcc9";

const NAV_LINKS = [
    { label: "Inicio", to: "/home" },
    { label: "Quiénes somos", to: "/quienes-somos" },
    { label: "Blog", to: "/blog" },
    { label: "Contáctanos", to: "/contactanos" },
];

export default function HeaderComponent() {
    const [menuOpen, setMenuOpen] = useState(false);

    return (
        <header style={{ background: "white", borderBottom: "1px solid #f0f0f0", position: "sticky", top: 0, zIndex: 1000 }}>
            <div className="hd-header-inner" style={{ maxWidth: 1100, margin: "0 auto", height: 70, padding: "0 32px", display: "flex", alignItems: "center", gap: 32 }}>
                {/* Logo */}
                <Link to="/home" style={{ display: "flex", alignItems: "center", gap: 8, textDecoration: "none", flexShrink: 0 }}>
                    <img
                        src="/logos.png"
                        alt="HeyDoctor"
                        style={{ height: 38, objectFit: "contain" }}
                        onError={(e) => {
                            (e.target as HTMLImageElement).outerHTML =
                                '<span style="font-size:1.3rem;font-weight:900;color:#0d1f2d;">Hey<span style="color:#4abcc9">doctor</span></span>';
                        }}
                    />
                </Link>

                {/* Nav — desktop */}
                <nav style={{ display: "flex", flex: 1, justifyContent: "center", gap: 2 }} className="hd-nav">
                    {NAV_LINKS.map(({ label, to }) => (
                        <Link
                            key={label}
                            to={to}
                            style={{
                                textDecoration: "none",
                                color: "#555",
                                fontSize: "0.875rem",
                                fontWeight: 600,
                                padding: "7px 16px",
                                borderRadius: 8,
                                fontFamily: "'Montserrat', sans-serif",
                                transition: "all 0.18s",
                                whiteSpace: "nowrap",
                            }}
                            onMouseEnter={(e) => {
                                (e.currentTarget as HTMLElement).style.color = "#257590";
                                (e.currentTarget as HTMLElement).style.background = "#f0f9fa";
                            }}
                            onMouseLeave={(e) => {
                                (e.currentTarget as HTMLElement).style.color = "#555";
                                (e.currentTarget as HTMLElement).style.background = "transparent";
                            }}
                        >
                            {label}
                        </Link>
                    ))}
                </nav>

                {/* CTA buttons — desktop */}
                <div className="hd-cta" style={{ display: "flex", alignItems: "center", gap: 16, flexShrink: 0 }}>
                    <Link
                        to="https://pacientes.heydoctor.com.mx/register"
                        target="_blank"
                        rel="noreferrer"
                        style={{ textDecoration: "none" }}
                    >
                        <button
                            style={{
                                background: TEAL,
                                border: "none",
                                color: "white",
                                padding: "11px 26px",
                                borderRadius: 10,
                                fontFamily: "'Montserrat', sans-serif",
                                fontSize: "0.88rem",
                                fontWeight: 700,
                                cursor: "pointer",
                                whiteSpace: "nowrap",
                                transition: "all 0.18s",
                            }}
                            onMouseEnter={(e) => {
                                (e.currentTarget as HTMLElement).style.background = "#257590";
                                (e.currentTarget as HTMLElement).style.transform = "translateY(-1px)";
                            }}
                            onMouseLeave={(e) => {
                                (e.currentTarget as HTMLElement).style.background = TEAL;
                                (e.currentTarget as HTMLElement).style.transform = "translateY(0)";
                            }}
                        >
                            Registrarme ahora
                        </button>
                    </Link>
                    <Link
                        to="https://pacientes.heydoctor.com.mx/login"
                        target="_blank"
                        rel="noreferrer"
                        style={{
                            color: TEAL,
                            fontWeight: 600,
                            fontSize: "0.95rem",
                            textDecoration: "none",
                            fontFamily: "'Montserrat', sans-serif",
                            whiteSpace: "nowrap",
                        }}
                    >
                        Iniciar sesión
                    </Link>
                </div>

                {/* Hamburger — mobile: marginLeft:auto lo empuja al extremo derecho */}
                <button
                    className="hd-hamburger"
                    onClick={() => setMenuOpen(!menuOpen)}
                    style={{ display: "none", background: "none", border: "none", cursor: "pointer", padding: 8, marginLeft: "auto" }}
                    aria-label="Menú"
                >
                    <span style={{ display: "block", width: 24, height: 2, background: "#0d1f2d", margin: "5px 0", transition: "all .2s" }} />
                    <span style={{ display: "block", width: 24, height: 2, background: "#0d1f2d", margin: "5px 0", transition: "all .2s" }} />
                    <span style={{ display: "block", width: 24, height: 2, background: "#0d1f2d", margin: "5px 0", transition: "all .2s" }} />
                </button>
            </div>

            {/* Mobile drawer */}
            {menuOpen && (
                <div style={{ background: "white", borderTop: "1px solid #f0f0f0", padding: "8px 24px 24px" }}>
                    {/* Nav links */}
                    {NAV_LINKS.map(({ label, to }) => (
                        <Link
                            key={label}
                            to={to}
                            onClick={() => setMenuOpen(false)}
                            style={{ display: "block", color: "#555", fontFamily: "'Montserrat',sans-serif", fontWeight: 600, fontSize: "0.95rem", padding: "13px 0", textDecoration: "none", borderBottom: "1px solid #f0f0f0" }}
                        >
                            {label}
                        </Link>
                    ))}

                    {/* Botones como items de lista */}
                    <Link
                        to="https://pacientes.heydoctor.com.mx/register"
                        target="_blank"
                        rel="noreferrer"
                        onClick={() => setMenuOpen(false)}
                        style={{ display: "block", color: TEAL, fontFamily: "'Montserrat',sans-serif", fontWeight: 700, fontSize: "0.95rem", padding: "13px 0", textDecoration: "none", borderBottom: "1px solid #f0f0f0" }}
                    >
                        Registrarme ahora →
                    </Link>
                    <Link
                        to="https://pacientes.heydoctor.com.mx/login"
                        target="_blank"
                        rel="noreferrer"
                        onClick={() => setMenuOpen(false)}
                        style={{ display: "block", color: TEAL, fontFamily: "'Montserrat',sans-serif", fontWeight: 600, fontSize: "0.95rem", padding: "13px 0", textDecoration: "none" }}
                    >
                        Iniciar sesión →
                    </Link>
                </div>
            )}

        </header>
    );
}
